import React, { useEffect } from 'react';
import HomeLayout from 'layouts/HomeLayout';
import { Link } from 'react-router-dom';
import { FaTimesCircle } from 'react-icons/fa';
import { trackLifetimeCheckoutAbandoned } from 'utils/tracking';
import './PaymentCancelled.scss';

const PaymentCancelled: React.FC = () => {
  useEffect(() => {
    trackLifetimeCheckoutAbandoned();
  }, []);

  return (
    <HomeLayout title="Payment Cancelled - Sellerdash">
      <div className="payment-cancelled-page">
        <div className="cancelled-card">
          <FaTimesCircle className="cancelled-icon" />
          <h1>Payment Cancelled</h1>
          <p className="cancelled-message">
            Your checkout was cancelled. No payment was taken.
          </p>
          <p className="cancelled-sub">
            Changed your mind? You can still claim your Lifetime Access whenever you're ready.
          </p>
          <Link to="/lifetime-subscription" className="btn-retry">
            Return to Lifetime Plan
          </Link>
          <p className="support-text">
            Need help? Email us at <a href="mailto:ask@sellerdash.pk">ask@sellerdash.pk</a>
          </p>
        </div>
      </div>
    </HomeLayout>
  );
};

export default PaymentCancelled;
